import { render, staticRenderFns } from "./Monitoring.vue?vue&type=template&id=164a2b9c&scoped=true&"
import script from "./Monitoring.vue?vue&type=script&lang=js&"
export * from "./Monitoring.vue?vue&type=script&lang=js&"
import style0 from "./Monitoring.vue?vue&type=style&index=0&id=164a2b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a2b9c",
  null
  
)

export default component.exports